import { maintenanceApi } from '@/api/maintenance'

class MaintenanceService {
  constructor() {
    this.isMaintenanceMode = false
    this.maintenanceMessage = ''
    this.scheduledMaintenance = null
    this.checkInterval = null
  }

  /**
   * Check if maintenance mode is active
   */
  async checkMaintenanceMode() {
    try {
      const response = await maintenanceApi.getStatus()
      
      this.isMaintenanceMode = response.isMaintenanceMode || false
      this.maintenanceMessage = response.maintenanceMessage || ''
      
      // Check for scheduled maintenance
      if (response.scheduledMaintenance) {
        this.scheduledMaintenance = {
          start: response.scheduledMaintenance.start,
          end: response.scheduledMaintenance.end,
          message: response.scheduledMaintenance.message || '',
          isUpcoming: response.scheduledMaintenance.isUpcoming || false,
          isActive: response.scheduledMaintenance.isActive || false
        }
      } else {
        this.scheduledMaintenance = null
      }
      
      // Return full response including super admin status
      return {
        isMaintenanceMode: this.isMaintenanceMode,
        maintenanceMessage: this.maintenanceMessage,
        scheduledMaintenance: this.scheduledMaintenance,
        isSuperAdmin: response.isSuperAdmin || false
      }
    } catch (error) {
      console.error('Error checking maintenance mode:', error)
      return {
        isMaintenanceMode: false,
        maintenanceMessage: '',
        scheduledMaintenance: null,
        isSuperAdmin: false
      }
    }
  }

  /**
   * Start periodic maintenance mode checks
   */
  startPeriodicCheck(intervalMs = 30000) {
    if (this.checkInterval) {
      clearInterval(this.checkInterval)
    }
    
    this.checkInterval = setInterval(async () => {
      const maintenanceStatus = await this.checkMaintenanceMode()
      if (maintenanceStatus.isMaintenanceMode && window.location.pathname !== '/maintenance-mode') {
        this.redirectToMaintenance()
      }
    }, intervalMs)
  }

  /**
   * Stop periodic checks
   */
  stopPeriodicCheck() {
    if (this.checkInterval) {
      clearInterval(this.checkInterval)
      this.checkInterval = null
    }
  }

  /**
   * Redirect to maintenance page
   */
  redirectToMaintenance() {
    if (window.location.pathname !== '/maintenance-mode') {
      window.location.href = '/maintenance-mode'
    }
  }

  /**
   * Check if current response indicates maintenance mode
   */
  checkResponseForMaintenance(response) {
    if (response?.data?.maintenance === true) {
      this.isMaintenanceMode = true
      this.maintenanceMessage = response.data.message || ''
      this.redirectToMaintenance()
      return true
    }
    return false
  }

  /**
   * Get current maintenance status
   */
  getStatus() {
    return {
      isMaintenanceMode: this.isMaintenanceMode,
      maintenanceMessage: this.maintenanceMessage,
      scheduledMaintenance: this.scheduledMaintenance
    }
  }
}

export const maintenanceService = new MaintenanceService()
export default maintenanceService
